import React from 'react'

class OrganizationTree extends React.Component {
  render() {
    const { page } = this.props

    return (
      <section className="organization-tree">
        {page.acf.organigramme_page.map((row, index) => (
          <React.Fragment key={index}>
            {row.__typename === 'WordPressAcf_one_item' && (
              <RowOneColumn row={row} />
            )}
            {/* {row.__typename === 'WordPressAcf_three_items' && (
              <RowThreeColumn row={row} customClass="" />
            )} */}
            {/* {row.__typename === 'WordPressAcf_three_items_dash' && (
              <RowThreeColumn row={row} customClass="dash" />
            )} */}
          </React.Fragment>
        ))}
      </section>
    )
  }
}

export default OrganizationTree

class RowOneColumn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleAccordion() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { open } = this.state
    const { title, subtitle, content } = this.props.row
    return (
      <div className="tree-row">
        <div className="tree-cell">
          <div
            onClick={() => this.toggleAccordion()}
            className={`cell-head ${open ? ' active' : ''}`}
          >
            <div className="item-trigger-content">
              <div className="cross">
                <span />
                <span />
              </div>
            </div>
            <h2 className="cell-title">{title}</h2>
            {subtitle != null && <div className="cell-name">{subtitle}</div>}
          </div>
          {content != null && (
            <div
              className="cell-text"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </div>
    )
  }
}

class RowThreeColumn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleAccordion() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { open } = this.state
    const { row, customClass } = this.props

    return (
      <div className={`tree-row three-items three-first-item ${customClass}`}>
        <div className="tree-row-child">
          {row.column_1.items.map((item, index) => (
            <React.Fragment key={index}>
              <TreeCell item={item} line={index === 0 ? 'line' : null} />
            </React.Fragment>
          ))}
        </div>
        <div className="tree-row-child">
          {row.column_2.items.map((item, index) => (
            <React.Fragment key={index}>
              <TreeCell item={item} line={null} />
            </React.Fragment>
          ))}
        </div>
        <div className="tree-row-child">
          {row.column_3.items.map((item, index) => (
            <React.Fragment key={index}>
              <TreeCell
                item={item}
                line={index === 0 ? 'line line-dashed' : null}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    )
  }
}

class TreeCell extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleAccordion() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { open } = this.state
    const { line } = this.props
    const { title, subtitle, content } = this.props.item
    return (
      <div className="tree-cell">
        {line !== null && <div className={line} />}
        <div
          onClick={() => this.toggleAccordion()}
          className={`cell-head ${open ? ' active' : ''}`}
        >
          <div className="item-trigger-content">
            <div className="cross">
              <span />
              <span />
            </div>
          </div>
          <h2 className="cell-title">{title}</h2>
          {subtitle != null && <div className="cell-name">{subtitle}</div>}
        </div>
        {content != null && (
          <div
            className="cell-text"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    )
  }
}
